<nav class="navbar navbar-default">
  <div class="container-fluid">
    <div class="navbar-header">
      <div type="button" (click)="menuToggle()" class="cursor-pointer">
        <span class="navbar-toggle toggled pi pi-angle-double-left" aria-hidden="true"></span>
      </div>
    </div>
    <div class="navbar-brand titulo-codex"> {{getTitulo()}}</div>
    <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
      <ul class="nav navbar-nav navbar-right">
        <li class="navbar__busca m-t-n-2">
          <button *ngIf="paths.permiteAlterarBackend"
            pButton icon="pi pi-database"
            class="p-button-danger p-button-sm"
            [pTooltip]="paths.base" tooltipPosition="top" tooltipStyleClass="backend-tooltip"
            appendTo="body"
            (click)="abrirBackendModal()"
          ></button>
          <div class="desktop">
            <p-autoComplete
              [(ngModel)]="rota"
              [suggestions]="rotaItens"
              (completeMethod)="onCompleteRota($event)"
              (onSelect)="onSelectRota($event)"
              [showEmptyMessage]="true"
              [emptyMessage]="'Nenhum resultado encontrado'"
              field="''"
              class="autocomplete-pages"
              placeholder="Pesquisar..."
              [dropdown]="true"
              dropdownIcon="pi pi-search">
              <ng-template let-item pTemplate="item">
                <div [innerHTML]="item.label"></div>
              </ng-template>
            </p-autoComplete>
          </div>
        </li>
        <li *ngIf="usuarioSessao" class="usuario-mobile m-t-n-2">
          <a [routerLink]="">
            <i class="pi pi-user fnt-toggle"></i>&nbsp;
            <p> {{usuarioSessao.nome}}</p>
          </a>
        </li>
        <li *ngIf="usuarioSessao" class="codex-sair m-t-n-2">
          <a [routerLink]="" (click)="deslogar()" class="icon-exit">
            <i class="pi pi-sign-out"></i>&nbsp;<p>Sair</p>
          </a>
        </li>
      </ul>
      <div class="mobile">
        <p-autoComplete
          [(ngModel)]="rota"
          [suggestions]="rotaItens"
          (completeMethod)="onCompleteRota($event)"
          (onSelect)="onSelectRota($event.value)"
          [showEmptyMessage]="true"
          [emptyMessage]="'Nenhum resultado encontrado'"
          [forceSelection]="true"
          field="value"
          class="autocomplete-pages"
          placeholder="Pesquisar..."
          [dropdown]="true"
          dropdownIcon="pi pi-search">
          <ng-template let-item pTemplate="item">
            <div [innerHTML]="item.label"></div>
          </ng-template>
        </p-autoComplete>
      </div>
    </div>
  </div>
</nav>

<p-dialog
  [showHeader]="true"
  [visible]="mostrarAlteraBackendModal"
  [modal]="true"
  [draggable]="false"
  [closable]="false"
  [style]="{width: '90%', maxWidth: '800px'}"
  appendTo="body">
  <div style="width: 100%">
    <div style="text-align: center; margin: 1em 0">
      <p>Use o campo para alterar a URL do backend atual:</p>
      <div class="p-fluid">
        <div class="p-grid">
          <div class="p-col-12 p-lg-2">
            <label for="urlAtual">URL Atual:</label>
          </div>
          <div class="p-col-12 p-lg-10">
            <input pInputText type="text" name="urlAtual" [(ngModel)]="paths.base" disabled />
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-12 p-lg-2">
            <label for="urlNova">URL Nova:</label>
          </div>
          <div class="p-col-12 p-lg-10">
            <input pInputText type="text" name="urlNova" [(ngModel)]="urlNova" />
          </div>
        </div>
      </div>
      <div style="margin: 1em 0">
        <button (click)="fecharBackendModal()" pButton type="button" label="Cancelar" class="p-button-danger" style="margin-right: 8px;"></button>
        <button [disabled]="!urlNova|| !urlNova.trim()" (click)="alterarBackendUrl()" pButton type="button" label="Alterar"></button>
      </div>
    </div>
  </div>
</p-dialog>
